import { AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialog, AlertDialogOverlay, Box, Button, Flex, useMediaQuery, AlertDialogBody, Link, AlertDialogCloseButton, Divider } from "@chakra-ui/react";
import { Icons, ToolTip, Typography, useFlowBuilderSession } from "@reconvert/react-ui-component";
import "./Sidebar.css";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDirection } from "../../hooks/useDirection";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import useUnsavedBar from "../../hooks/useUnsavedBar";
import { selectAppState, setActivePage, setIsSidebarSticked, toggleSideBar, getSubscriptionDetailsAsync, updateSubscriptionAsync, toggleHelpModal, setShowFlowBuilder } from "../../app/slice/appSlice";
import { getSlotsForPageAsync } from "../../app/slice/slotSlice";
import { LinkItem } from "../../app/slice/appSlice.model";
import { Platform } from "../../models";
import {
  SegmentEventPageNames,
  UNLEASH_ENABLE_WIX_PRODUCT_PAGE,
  UNLEASH_SHOW_CART_DRAWER,
} from "../../utils/constant";
import { APP_PLATFORM, APP_PREFIX, LATEST_PLAN_ID, LATEST_PLAN_MAX_CAP, RECONVERT_IO_HELP_URL } from "../../config";
import { PageType,Platform as UpsellPlatform } from "@reconvert/reconvert-utils";
import DynamicBanner from "../DynamicBanner/DynamicBanner";
import { BookDemoBanner } from "../BookDemoBanner";
import { selectShopInfoState } from "../../ReviewProviderWrapper";
import { sendSegmentEvent } from "../../services/segment.service";
import { updateShopInfoLocal, updateShopInfoThunk } from "../../app/slice/shopinfoSlice";
import { FunctionRegistry } from "../../utils/functionRegistry";

export const PrePurchaseLinkItems: Array<LinkItem> = [
  {
    name: "Product page (beta)",
    icon: <Icons.Tag color="#6A7381" />,
    type: PageType.PRE_PURCHASE_PRODUCT_PAGE,
    activeIcon: <Icons.Tag height={"20px"} width={"20px"} color="primary.400" />,
    allowedPlatform: [Platform.Shopify, Platform.Wix],
    unleashFlag: UNLEASH_ENABLE_WIX_PRODUCT_PAGE,
  },
  {
    name: "Cart page (beta)",
    icon: <Icons.ShoppingCart color="#6A7381" />,
    type: PageType.PRE_PURCHASE_CART_PAGE,
    activeIcon: <Icons.ShoppingCart height={"20px"} width={"20px"} color="primary.400" />,
    allowedPlatform: [Platform.Shopify],
  },
  {
    name: "Cart drawer (beta)",
    icon: <Icons.ShoppingCartPlus color="#6A7381" />,
    type: PageType.PRE_PURCHASE_CART_DRAWER_PAGE,
    activeIcon: <Icons.ShoppingCartPlus height={"20px"} width={"20px"} color="primary.400" />,
    allowedPlatform: [Platform.Shopify],
    unleashFlag: UNLEASH_SHOW_CART_DRAWER,
  },
  {
    name: "Checkout",
    icon: <Icons.CreditCard color="#6A7381" />,
    type: PageType.CHECKOUT,
    activeIcon: <Icons.CreditCard height={"20px"} width={"20px"} color="primary.400" />,
    allowedPlatform: [Platform.Shopify, Platform.Wix],
  },
];

export const PostPurchaseLinkItems: Array<LinkItem> = [
  {
    name: "Post purchase 1st",
    icon: <Icons.ShoppingBag color="#6A7381" />,
    type: PageType.POST_PURCHASE_PAGE1,
    activeIcon: <Icons.ShoppingBag height={"20px"} width={"20px"} color="primary.400" />,
    allowedPlatform: [Platform.Shopify],
  },
  {
    name: "Post purchase 2nd",
    icon: <Icons.ShoppingBag color="#6A7381" />,
    type: PageType.POST_PURCHASE_PAGE2,
    activeIcon: <Icons.ShoppingBag height={"20px"} width={"20px"} color="primary.400" />,
    allowedPlatform: [Platform.Shopify],
  },
  {
    name: "Thank you page",
    icon: <Icons.CircleWavyCheck color="#6A7381" />,
    type: PageType.THANK_YOU_PAGE,
    activeIcon: <Icons.CircleWavyCheck height={"20px"} width={"20px"} color="primary.400" />,
    allowedPlatform: [Platform.Shopify],
  },
  {
    name: "Order status page",
    icon: <Icons.OrderStatus color="#6A7381" />,
    type: PageType.ORDER_STATUS_PAGE,
    activeIcon: <Icons.OrderStatus height={"20px"} width={"20px"} color="primary.400" />,
    allowedPlatform: [Platform.Shopify],
  },
];

const ActionLinkItems: Array<LinkItem> = [
  // {
  //   name: "Add to card",
  //   icon: <Icons.ShoppingCart color="#6A7381" />,
  //   type: PageType.CART_PAGE,
  //   activeIcon: <Icons.ShoppingCart height={"20px"} width={"20px"} color="primary.400" />,
  //   allowedPlatform: [Platform.Shopify],
  // },
];

export const SECTIONS = [
  {
    name: APP_PLATFORM === Platform.Shopify ? "PRE PURCHASE" : "PAGES",
    links: PrePurchaseLinkItems,
    enabled: true,
  },
  ...(APP_PLATFORM === Platform.Shopify
    ? [
      {
        name: "POST PURCHASE",
        links: PostPurchaseLinkItems,
        enabled: true,
      },
    ]
    : []),
  // {
  //   name: "ACTIONS",
  //   links: ActionLinkItems,
  //   enabled: false,
  // },
];

export const DashboardVersion2Pages = [
  PageType.POST_PURCHASE_PAGE1,
  PageType.POST_PURCHASE_PAGE2,
  PageType.THANK_YOU_PAGE,
  PageType.ORDER_STATUS_PAGE,
];

const Sidebar = () => {
  const { t } = useTranslation();
  const { isRTL } = useDirection();
  const [hover, setHover] = useState(false);
  const { activePage, isSidebarCollapased, isSidebarSticked, sideBarSections, subscriptionDetails, showHelpModal, showFlowBuilder } = useAppSelector(selectAppState);
  const { shopInfo } = useAppSelector(selectShopInfoState);
  const { preventAction } = useUnsavedBar();
  const { setPageInSession, getFlowBuilderUrlFromSession ,setFlowBuilderUrlInSession } = useFlowBuilderSession();
  const [isSmallScreen] = useMediaQuery("(max-width: 1580px)");
  const [showPrePurchaseOfferDialog, setShowPrePurchaseOfferDialog] = useState(false);
  const [selectedPage, setSelectedPage] = useState<PageType | null>(null);
  const dispatch = useAppDispatch();
  const modalRef = useRef<HTMLDivElement>(null);
  const activePageRef = useRef<HTMLDivElement>(null);

  useEffect(() => setPageInSession(activePage), [activePage]);

  useEffect(() => {
    if (activePageRef.current) {
      activePageRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [activePage]);

  useEffect(() => {
    if (isSmallScreen && !isSidebarCollapased && showFlowBuilder) {
      dispatch(toggleSideBar());
      dispatch(setIsSidebarSticked(false));
    }
  }, [isSmallScreen,showFlowBuilder]);

  // Auto-open help modal on page load when showFlowBuilder is true
  useEffect(() => {
    if (
      showFlowBuilder &&
      APP_PLATFORM === Platform.Shopify &&
      shopInfo?.show_help_video_modal === "0" 
    ) {
      dispatch(
        toggleHelpModal({
          link: `${RECONVERT_IO_HELP_URL}/en/article/how-to-use-the-flow-builder-120kpr5/reader/?bust=1706874298491`,
          title: t("How to use the Flow Builder").toString(),
        }),
      );
    }
  }, [showFlowBuilder, shopInfo?.show_help_video_modal, dispatch, t]);

  useEffect(() => {
    const reconvertImage = new Image();

    reconvertImage.src = APP_PREFIX + "/upsellcom_text.svg";
    reconvertImage.onload = () => console.log("reconvert-Image preloaded");
    reconvertImage.onerror = error => console.error("Error preloading reconvert-Image", error);

    return () => {
      reconvertImage.onload = null;
      reconvertImage.onerror = null;
    };
  }, []);

  const handleDialogClose = () => {
    setShowPrePurchaseOfferDialog(false);
    setSelectedPage(null);
  };

  // Helper function to fetch slots for a specific page if not already cached
  const ensureSlotsForPage = async (pageType: PageType): Promise<boolean> => {
    try {
      const result = await dispatch(getSlotsForPageAsync(pageType)).unwrap();

      if (result.slots.length > 0) {
        return true;
      }
    } catch (error) {
      console.error('Error fetching slots for page:', error);
    }

    return false;
  };

  const handleDialogApprove = async () => {
    try {
      await dispatch(updateSubscriptionAsync({
        planId: LATEST_PLAN_ID,
        maxCap: LATEST_PLAN_MAX_CAP
      })).unwrap();
      dispatch(getSubscriptionDetailsAsync());
      setShowPrePurchaseOfferDialog(false);
      dispatch(setActivePage(selectedPage as PageType));
      setSelectedPage(null);
    } catch (error) {
      console.log(error);
    }
  };

  const removeQueryParamsFromUrl = () => {
    const url = getFlowBuilderUrlFromSession();
    
    if (url) {
      const [pathname, search] = url.split('?');
      const searchParams = new URLSearchParams(search);

      // decode fbq param and remove showWelcomePage (if it exists)
      if (searchParams.has('fbq')) {
        try {
          const fbq = searchParams.get('fbq') || '';
          const decoded = atob(fbq);
          const fbqParams = new URLSearchParams(decoded);

          fbqParams.delete('showWelcomePage');

          // re-encode and set back
          const newFbq = btoa(fbqParams.toString());
          
          searchParams.set('fbq', newFbq);
        } catch (e) {
          // fallback: do nothing if decode fails
          console.error('Error decoding fbq in removeQueryParamsFromUrl', e);
        }
      }

      // reconstruct the url
      const newUrl = pathname + '?' + searchParams.toString();
      
      setFlowBuilderUrlInSession(newUrl);
    }
  };

  FunctionRegistry.removeQueryParamsFromUrl = removeQueryParamsFromUrl;
  
  const handlePageLinkClick = async (link: LinkItem) => {
    if (link.disabled) return;

    const pageType = link.type as PageType;

    // Check if it's a pre-purchase page and user doesn't have latest plan
    const isPrePurchasePage = 
      pageType === PageType.PRE_PURCHASE_PRODUCT_PAGE || 
      pageType === PageType.PRE_PURCHASE_CART_PAGE || 
      pageType === PageType.PRE_PURCHASE_CART_DRAWER_PAGE;

    if (isPrePurchasePage && subscriptionDetails && !subscriptionDetails?.isLatestPlan) {
      // Fetch slots for this specific page and check if it has slots
      const hasSlots = await ensureSlotsForPage(pageType);

      if (!hasSlots) {
        setShowPrePurchaseOfferDialog(true);
        setSelectedPage(pageType);
        return;
      }
    }

    // Track segment event for first page selection on Shopify
    // Check before setting showFlowBuilder to true
    const isFirstPageSelection = !showFlowBuilder && APP_PLATFORM === UpsellPlatform.SHOPIFY && shopInfo?.first_page_selected === "0";

    if (isFirstPageSelection && shopInfo?.store_client_id) {
      try {
        await sendSegmentEvent(
          shopInfo?.store_client_id,
          'flow builder - first page selected',
          {
            'user id': shopInfo?.store_client_id,
            'date & time': new Date().toISOString(),
            'store name': shopInfo?.store_name,
             platform: "Shopify",
            'store url': shopInfo?.store_name,
            'myshopify url': shopInfo?.store_name,
            'page clicked': SegmentEventPageNames[pageType],
          }
        );
        dispatch(updateShopInfoLocal({
          first_page_selected: "1",
        }));
        dispatch(updateShopInfoThunk({
          first_page_selected: "1",
        }));

      } catch (error) {
        console.error('Error sending segment event:', error);
      }
    }

    dispatch(setShowFlowBuilder(true));

    // Remove showWelcomePage query param from url
    removeQueryParamsFromUrl();

    dispatch(setActivePage(pageType));
  };

  return (
    <Flex
      sx={{
        h: "100vh",
        bg: "grays.1",
        boxShadow: "shadow-med",
        flexDirection: "column",
      }}
      className={`sidebar ${!isSidebarCollapased || hover ? "sidebar--open" : ""}`}
      position="absolute"
      zIndex="2"
      onMouseLeave={() => {
        if (hover) {
          !isSidebarSticked && dispatch(toggleSideBar());
          setHover(false);
        }
      }}
      onMouseEnter={() => {
        if (isSidebarCollapased) {
          setHover(true);
          dispatch(toggleSideBar());
        }
      }}
    >
      <Flex
        sx={{
          padding: "24px",
          alignItems: "center",
          justifyContent: "start",
          flexShrink: 0,
        }}
      >
        <>
          <img src={APP_PREFIX + "/reconvert-circle-logo.svg"} width={"32px"} height={"32px"} alt="Logo" />

          <img
            src={APP_PREFIX + "/upsellcom_text.svg"}
            alt="reconvert_icon"
            style={{
              padding: isRTL ? "8px 8px 8px 0" : "8px 0 8px 8px"
            }}
            className={isSidebarCollapased ? "sidebar-icon-animate-out" : "sidebar-icon-animate-in"}
            height={"16px"}
            width={"98px"}
          />

          <Icons.CollapsedMenuLeft
            onClick={() => {
              hover && setHover(false);
              isSidebarSticked && !isSidebarCollapased && !hover && setHover(true);
              dispatch(setIsSidebarSticked(!isSidebarSticked));
            }}
            style={{
              transform: !isSidebarSticked ? "scaleX(-1)" : "",
              ...(isRTL ? { left: "28px" } : { right: "28px" }),
            }}
            className={isSidebarCollapased ? "sidebar-icon-animate-out" : "sidebar-icon-animate-in"}
            color="neutrals.500"
            cursor="pointer"
            position="absolute"
          />
        </>
      </Flex>

      <Flex
        sx={{
          flex: 1,
          flexDirection: "column",
          overflowY: "auto",
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE/Edge
          "&::-webkit-scrollbar": {
            display: "none", // Chrome/Safari/Opera
          },
        }}
      >
        <Box>
          {sideBarSections.map((sec, mainIndex) => {
            return (
              <Box px="20px" key={mainIndex}>
                <Typography
                  variant="body"
                  color="neutrals.500"
                  fontWeight={"medium"}
                  mb={2}
                  whiteSpace={"nowrap"}
                  className={isSidebarCollapased ? "sidebar-text-animation-out" : "sidebar-text-animation-in"}
                  style={{ fontVariant: "titling-caps" }}
                >
                  {t(sec.name)}
                </Typography>
                {sec.links.map((link, index) => (
                  <ToolTip alignItems="center" placement="top" label={link.toolTip} hidden={!link.disabled}>
                    <Box
                      key={index}
                      ref={link.type === activePage && showFlowBuilder ? activePageRef : null}
                      sx={{
                        display: "flex",
                        gap: 2,
                        h: 10,
                        alignItems: "center",
                        p: "8px",
                        my: 2,
                        justifyContent: "center",
                        borderRadius: "lg",
                        cursor: "pointer",
                        height: "min-content",
                        minWidth: "36px",
                        width: isSidebarCollapased ? "fit-content" : "auto",
                        position: "relative",
                      }}
                      className="sidebar-position"
                      bg={link.type === activePage && showFlowBuilder ? "neutrals.100" : undefined}
                      _hover={{
                        bg: "neutrals.100",
                        borderRadius: 8,
                      }}
                      onClick={() => preventAction(() => handlePageLinkClick(link))}
                    >
                      <Flex width={"20px"}>{link.type === activePage && showFlowBuilder ? link.activeIcon : link.icon}</Flex>
                      <Box
                        flex={1}
                        overflow="hidden"
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                        pr={isSidebarCollapased ? 0 : "24px"}
                      >
                        <Typography
                          variant="body"
                          fontWeight={500}
                          color={link.disabled ? "disable.color" : link.type === activePage && showFlowBuilder ? "primary.400" : "black"}
                          className={isSidebarCollapased ? "sidebar-animate-out" : "sidebar-animate-in"}
                          overflow="hidden"
                          textOverflow="ellipsis"
                          whiteSpace="nowrap"
                        >
                          {t(link.name)}
                        </Typography>
                      </Box>
                      <Icons.CaretRight
                        color={link.type === activePage && showFlowBuilder ? "primary.400" : "neutrals.500"}
                        className={isSidebarCollapased ? "sidebar-icon-animate-out" : "sidebar-icon-animate-in"}
                        style={{
                          position: "absolute",
                          ...(isRTL ? { left: "8px" } : { right: "8px" }),
                          display: isSidebarCollapased ? "none" : "block",
                        }}
                      />
                    </Box>
                  </ToolTip>
                ))}
                {mainIndex !== sideBarSections.length - 1 && <Divider orientation="horizontal" my={4} />}
              </Box>
            );
          })}
        </Box>

        <Box sx={{ flex: 1 }} />

        <Box className={isSidebarCollapased ? "sidebar-animate-out" : "sidebar-animate-in"}>
          <DynamicBanner direction={"left"} />
          {APP_PLATFORM === Platform.Shopify && !showHelpModal &&
            <div>
              <BookDemoBanner location="flow_builder" marginBottom="9px" isVertical={true} />
            </div>
          }
        </Box>
      </Flex>
      <AlertDialog
        isOpen={showPrePurchaseOfferDialog}
        onClose={handleDialogClose}
        isCentered
        size={'3xl'}
        leastDestructiveRef={modalRef}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader
              fontSize="lg"
              fontWeight="bold"
              borderBottom="1px solid"
              borderBottomColor="divider.1"
            >
              <Typography variant="h3-medium" color="neutrals.900">
                {t('Unlock pre-purchase offers')}
              </Typography>
            </AlertDialogHeader>
            <AlertDialogCloseButton marginTop={'-5px'} />
            <AlertDialogBody
              color="neutrals.900"
              px="24px"
              mx={0}
              py={3}
              borderBottom="1px solid"
              borderBottomColor="divider.1"

            >
              <Typography variant="body-16-regular" color="neutrals.900">
                {t(`You’re about to set up a pre-purchase offer. These offers are only available on our latest pricing plan. Since you're currently on a legacy plan, moving forward with this setup will automatically switch you to the`)}{' '}
                <span style={{ fontWeight: '500' }}>
                  {t('latest ReConvert pricing plan.')}
                </span>
              </Typography>

              <Typography marginTop={'20px'} variant="body-16-regular"  color="neutrals.900">
                {t(`Don’t worry - your existing offers will remain the same, and you’ll also get access to the newest tools, improvements, and updates first.`)}
              </Typography>

              <Typography marginTop={'25px'} variant="body-16-regular"  color="neutrals.900">
                {t(`Need details?`)}{' '}
                <Link href="https://help.reconvert.io/en/article/how-much-does-reconvert-cost-is-there-a-free-trial-transparent-pricing-no-hidden-fees-full-access-14-day-free-trial-rousx9/" isExternal={true} color="neutrals.900" textDecor={'underline'}>
                  {t('See full pricing update')}
                </Link>
              </Typography>
            </AlertDialogBody>

            <AlertDialogFooter
              h="44px"
              my="24px"
              py={0}
            >
              <Button variant='secondary' onClick={handleDialogClose} height={'44px'}>
                <Typography fontWeight={500} variant="body-16-regular"  color="neutrals.900">
                  {t('Later')}
                </Typography>
              </Button>
              <Button onClick={handleDialogApprove} ml={2} height={'44px'}>
                <Typography fontWeight={500} variant="body-16-regular"  >
                  {t('Approve & continue')}
                </Typography>
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Flex>
  );
};

export default Sidebar;
